import {useStore} from "vuex";
import {computed, ref} from "vue";
import {User} from "@typings/user";
import {authorizationCheck} from "@utils/auth";
import store from "@/store";

let menuList = null
export const defaultPath = {
    value: null
}

export const menuRouteDic = {
    '/home': {title: '数据大屏', path: '/data', permission: 1 },
}

// const userInfo =  store.getters['app/userInfo']
const menuTree = [
    {title: '数据大屏', path: '/data', permission: 1, notRouter: false },
    {title: '设备大屏', path: '/device', permission: 2, notRouter: false},
    {title: '运维大屏', path: '/operationAndMaintenance', permission: 3, notRouter: false},
    {
        title: '数据报表', path: '1', permission: 4, children: [
            {title: '运行数据', path: '/opertion', permission: 13},
            {title: '设备数据', path: '/deviceData', permission: 12}
        ]
    },
    {
        title: '异常报警', path: '2', permission: 5,
        children: [
            {title: '报警分析', path: '/analyse', permission: 14},
            {title: '报警数据', path: '/alarmdata', permission: 91},
            {title: '报警触发器', path: '/trigger', permission: 80},
            {title: '推送管理', path: '/push', permission: 81},
        ]
    },
    {
        title: '巡检任务', path: '3', permission: 6,
        children: [
            {title: '巡检分析', path: '/analysis', permission: 18},
            {title: '巡检任务', path: '/tasks', permission: 19},
            {title: '巡检项管理', path: '/inspectionItem', permission: 81},
            {title: '巡检排班管理', path: '/inspector', permission: 82},
            {title: '巡检计划管理', path: '/scheme', permission: 83},

        ]
    },
    {
        title: '维修任务', path: '4', permission: 7,
        children: [
            {title: '维修分析', path: '/maAnalysis', permission: 23},
            {title: '维修任务', path: '/task', permission: 84},
            {title: '维修员管理', path: '/manage', permission: 85},
        ]
    },
    {
        title: '视频监控', path: '5', permission: 8,
        children: [
            {title: '监控中心', path: '/cameraView', permission: 26},
            {title: '监控管理', path: '/cameraManage', permission: 85},
        ]
    },
    {
        title: '设备管理', path: '6', permission: 9,
        children: [
            {title: '设备管理', path: '/management', permission: 86},
            {title: '变量模版', path: '/VariableTemplate', permission: 87},
        ]
    },
    {
        title: '系统管理', path: '7', permission: 10,
        children: [
            {title: '用户管理', path: '/user', permission: 88},
            {title: '权限管理', path: '/limits', permission: 89},
            {title: '片区管理', path: '/area', permission: 90},
        ]
    },
    {
        title: '日志', path: '8', permission: 11,
        children: [
            {title: '登录日志', path: '/loginlog', permission: 34},
            {title: '操作日志', path: '/operate', permission: 35},
            {title: '设备日志', path: '/devicelog', permission: 36},
        ]
    },
]

// 获取存储在vuex中的值
export function getMenuList (){
    if (menuList) return menuList
    // const roleListTree = userInfo.value.menuId.split(',')
    // const roleTree = roleListTree.map(item => item.replace(/^D?(.*)$/, '$1'))
    recursionDic(menuTree)
    return recursion(menuTree)
}

function recursionDic (childrenMenu){
    return childrenMenu.forEach(function (menu){
        menuRouteDic[menu.path] = menu
        if (menu.children?.length){
            recursionDic(menu.children)
        }
    })
}

function recursion (childrenMenu){
    return childrenMenu.filter(function (menu){
        if (authorizationCheck(menu.permission,[])){

            if (menu.children?.length){
                menu.children = recursion(menu.children)
            } else if(menu.notRouter !== false && !defaultPath.value) {

                defaultPath.value = menu.path
            }
            return true
        }else{
            return false
        }
    })
}
